module.exports = __webpack_public_path__ + "static/InsideBreaker-309b8f97e97cfa01b2cce79340fb5fa9.png";